import { BasicCrudService } from '@/app/common/utils/crud/basic-crud.service';
import { Injectable } from '@angular/core';
import { ChecklistApiService } from '../infra/api.service';
import {
  Checklist,
  ChecklistFindAllParams,
  ChecklistCreateParams,
} from './type';
import { User } from '../../user/core/type';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';

@Injectable({ providedIn: 'root', useClass: ChecklistApiService })
export abstract class ChecklistService extends BasicCrudService<
  Checklist,
  Checklist['id'],
  ChecklistFindAllParams,
  Checklist,
  ChecklistCreateParams
> {
  abstract override findAll(
    filter?: ChecklistFindAllParams | undefined
  ): Observable<PaginatedResponse<Checklist>>;
}
